import { searchTerminalContextSchema } from "@wags/discovery/search/search-correlation.contract.ts";
import { z } from "zod";

export const searchNavigationContextSchema = z.object({
    runtimeId: z.uuid(),
    context: searchTerminalContextSchema,
});
